import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";

import starsAnimation from "../../misc/lotti/dwshs.json";

export default function DancingWithStarsHeroBlock() {
  const navigate = useNavigate();
  const { t } = useTranslation("heropage");

  return (
    <Box
      sx={{
        position: "relative",
        mx: { xs: 2.5, md: 6 },
        mt: { xs: 8, md: 12 },
        mb: { xs: 12, md: 16 },
        borderRadius: "30px",
        overflow: "hidden",
        backgroundColor: "#050508",
        boxShadow: "0 50px 140px rgba(0,0,0,0.7)",
      }}
    >
      {/* BASE DEPTH GRADIENT */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(120deg, #050508 0%, #0B0D1A 40%, #14162A 70%, #070711 100%)",
          zIndex: 0,
        }}
      />

      {/* ANIMATED WAVE GRADIENT */}
      <motion.div
        animate={{ backgroundPositionX: ["0%", "100%"] }}
        transition={{
          duration: 18,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg, rgba(35,38,92,0.25), rgba(160,120,255,0.12), rgba(35,38,92,0.25))",
          backgroundSize: "200% 100%",
          opacity: 0.6,
          zIndex: 1,
        }}
      />

      {/* SECONDARY SOFT WAVE */}
      <motion.div
        animate={{ backgroundPositionX: ["100%", "0%"] }}
        transition={{
          duration: 26,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(90deg, rgba(255,255,255,0.04), rgba(120,90,255,0.06), rgba(255,255,255,0.04))",
          backgroundSize: "220% 100%",
          zIndex: 2,
        }}
      />

      {/* LOTTIE STARS */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 3,
          pointerEvents: "none",
          opacity: 0.4,
        }}
      >
        <Lottie
          animationData={starsAnimation}
          loop
          style={{ width: "100%", height: "100%" }}
        />
      </Box>

      {/* CONTENT */}
      <Box
        sx={{
          position: "relative",
          zIndex: 4,
          px: { xs: 4, md: 9 },
          py: { xs: 7, md: 9 },
          maxWidth: 760,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "2rem", md: "2.7rem" },
            color: "#FFFFFF",
            mb: 2.5,
            letterSpacing: "0.02em",
          }}
        >
          {t("dancingWithStars.title")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: "0.98rem",
            lineHeight: 1.95,
            color: "rgba(255,255,255,0.8)",
            mb: 4.5,
          }}
        >
          {t("dancingWithStars.description")}
        </Typography>

        <Button
          onClick={() => navigate("/dancing-with-the-stars")}
          sx={{
            px: 4.5,
            py: 1.5,
            borderRadius: "999px",
            textTransform: "none",
            fontFamily: "Inter",
            fontSize: "0.85rem",
            letterSpacing: "0.14em",
            color: "#0A0A12",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 14px 36px rgba(255,255,255,0.3)",
            "&:hover": {
              backgroundColor: "#EFEFEF",
            },
          }}
        >
          {t("dancingWithStars.cta")}
        </Button>
      </Box>
    </Box>
  );
}
